import { PageRouteBuilder } from "@common/route/page-route-builder";
import { CopySystemPageComponent } from "./copy-system-page.component";

export const copySystemPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-copy-system-page", CopySystemPageComponent)
    .requiresLogin()
    .atUrl("/tools/copy-system")
    .withTitle("Copy System")
    .build();
